<div class="manual-shell">
  <app-header />

  <div class="main-layout">
    <app-sidebar />
    <div class="content-area" [class.shifted]="sidebarService.isOpen()">
      <router-outlet />
      <app-footer />
    </div>
  </div>

</div>
